import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-portal-questions-and-answers',
  templateUrl: './portal-questions-and-answers.component.html',
  styleUrls: ['./portal-questions-and-answers.component.scss']
})
export class PortalQuestionsAndAnswersComponent {
    @Input() data: any;
}
